import { render, staticRenderFns } from "./SpeedTestBlock.vue?vue&type=template&id=2fcec9da"
import script from "./SpeedTestBlock.vue?vue&type=script&lang=ts"
export * from "./SpeedTestBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports